import { Player } from "@/lib/types";
import { useTranslation } from "react-i18next";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
// import { Badge } from "@/components/ui/badge";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Monitor, Smartphone, Laptop } from "lucide-react";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import { DashboardPlayerHealthStatus } from "@/pages/dashboard/DashboardPlayerHealthStatus";

interface Props {
  players: Player[];
}

export const AssignedPlayersRenderer = ({ players }: Props) => {
  const { t } = useTranslation();
  const { goToPlayerDetail } = useAppNavigate();

  const getDeviceIcon = (deviceType: string) => {
    switch (deviceType?.toLowerCase()) {
      case "mobile":
        return <Smartphone className="h-4 w-4 mr-2" />;
      case "tablet":
        return <Laptop className="h-4 w-4 mr-2" />;
      default:
        return <Monitor className="h-4 w-4 mr-2" />;
    }
  };

  if (!players.length) {
    return (
      <Card className="w-full">
        <CardHeader>
          <CardTitle>{t("common.assignedPlayers")}</CardTitle>
          <CardDescription>{t("common.assignedPlayersEmpty")}</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-40 flex flex-col items-center justify-center text-muted-foreground">
            <Monitor className="h-12 w-12 mb-2" />
            <p>{t("common.assignedPlayersEmpty")}</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>{t("common.assignedPlayers")}</CardTitle>
        <CardDescription>{t("common.assignedPlayersDesc", { count: players.length })}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="rounded-md border">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t("common.name")}</TableHead>
                <TableHead className="hidden md:table-cell">{t("playerInfo.deviceType")}</TableHead>
                <TableHead className="hidden md:table-cell">{t("common.manufacturer")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {players.map((player: Player) => (
                <TableRow key={player.id}>
                  <TableCell className="font-medium">
                    <div className="flex items-center cursor-pointer" onClick={() => goToPlayerDetail(player.id)}>
                      {getDeviceIcon(player.deviceType)}
                      <span className="mr-2">{player.name}</span>
                      <DashboardPlayerHealthStatus playerId={player.intId} />
                    </div>
                  </TableCell>
                  <TableCell className="hidden md:table-cell">{player.deviceType || t("Unknown")}</TableCell>
                  <TableCell className="hidden md:table-cell">{player.manufacturer || t("Unknown")}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
};
